import { Context } from '@leverege/plugin';
import { Toast } from '@leverege/ui-elements';
import { getInvoiceResource } from '../../util/Interface';
const downloadSalesCSVAction = {
  id: 'billing.downloadSales',
  name: 'Download Sales Report',
  layout: {
    sort: 'z.billing.2',
    sectionName: 'Billing Downloads'
  },
  matches: {
    use: ['contextMenu', 'mobileActionBar'],
    client: 'ItemInfoScreen',
    objectType: 'bill'
  },
  handles: checkForCSVAvailability,
  appearance: () => ({
    name: 'Download Sales Report'
  }),
  perform: async ({
    context
  }) => {
    callAPI(context, 'salesCSV');
  }
};
const downloadRefundsCSVAction = {
  id: 'billing.downloadRefunds',
  name: 'Download Refunds Report',
  layout: {
    sort: 'z.billing.3',
    sectionName: 'Billing Downloads'
  },
  matches: {
    use: ['contextMenu', 'mobileActionBar'],
    client: 'ItemInfoScreen',
    objectType: 'bill'
  },
  handles: checkForCSVAvailability,
  appearance: () => ({
    name: 'Download Refunds Report'
  }),
  perform: async ({
    context
  }) => {
    callAPI(context, 'refundsCSV');
  }
};
const downloadLostLocatorsCSVAction = {
  id: 'billing.downloadLostLocators',
  name: 'Download Lost Locators Report',
  layout: {
    sort: 'z.billing.4',
    sectionName: 'Billing Downloads'
  },
  matches: {
    use: ['contextMenu', 'mobileActionBar'],
    client: 'ItemInfoScreen',
    objectType: 'bill'
  },
  handles: checkForCSVAvailability,
  appearance: () => ({
    name: 'Download Lost Locators Report'
  }),
  perform: async ({
    context
  }) => {
    callAPI(context, 'lostLocatorsCSV');
  }
};
const downloadFoundLocatorsCSVAction = {
  id: 'billing.downloadFoundLocators',
  name: 'Download Found Locators Report',
  layout: {
    sort: 'z.billing.5',
    sectionName: 'Billing Downloads'
  },
  matches: {
    use: ['contextMenu', 'mobileActionBar'],
    client: 'ItemInfoScreen',
    objectType: 'bill'
  },
  handles: checkForCSVAvailability,
  appearance: () => ({
    name: 'Download Found Locators Report'
  }),
  perform: async ({
    context
  }) => {
    callAPI(context, 'foundLocatorsCSV');
  }
};
async function callAPI(context, resourceName) {
  const systemId = context?.clientProps?.item?.systemId;
  const companyId = context?.clientProps?.item?.data?.company?.id;
  const locationId = context?.clientProps?.item?.data?.location?.id;
  const billingId = context?.clientProps?.item?.id;
  try {
    await getInvoiceResource(systemId, companyId, locationId, billingId, resourceName);
  } catch (err) {
    Toast.error('Error downloading CSV');
  }
}
function checkForCSVAvailability(context) {
  const bill = Context.getTargetOfType(context, 'bill');
  return bill?.data?.data?.csvAvailable;
}
export default {
  install(molten) {
    molten.addPlugin('Action', downloadSalesCSVAction);
    molten.addPlugin('Action', downloadRefundsCSVAction);
    molten.addPlugin('Action', downloadLostLocatorsCSVAction);
    molten.addPlugin('Action', downloadFoundLocatorsCSVAction);
  }
};